import React, { useState } from 'react';
import { usePortal } from '../../contexts/PortalContext';
import { BUTTON_QUIET, BUTTON_SOLID, FIELD } from './adminStyles';

/**
 * Secondary project options, kept off the main action row and off the projects
 * dashboard. Permanent deletion lives here, behind a typed confirmation, for
 * test, duplicate or accidentally created projects only. Archive remains the
 * normal action for real work.
 */
export function ProjectOptions() {
  const {
    activeProject,
    deleteProject
  } = usePortal();
  const [open, setOpen] = useState(false);
  const [confirming, setConfirming] = useState(false);
  const [typed, setTyped] = useState('');
  const [busy, setBusy] = useState(false);
  const matches = typed.trim() === activeProject.name.trim();
  function close() {
    setConfirming(false);
    setTyped('');
  }
  return <section className="mt-16 border-t border-ruleDark pt-8" data-id="element-347" data-mp="3dxe4ac1lnxyd">
      <button type="button" onClick={() => {
      setOpen(current => !current);
      close();
    }} aria-expanded={open} className="label-sm text-paper/35 underline underline-offset-4 transition-colors duration-150 ease-out hover:text-paper/70" data-id="element-348" data-mp="39varnk372nbi">
        {open ? 'Hide Project Options' : 'Project Options'}
      </button>

      {open && !confirming && <div className="mt-6" data-id="element-349" data-mp="2p0wfpwssup1e">
          <button type="button" onClick={() => setConfirming(true)} className="label text-paper/40 transition-colors duration-150 ease-out hover:text-paper" data-id="element-350" data-mp="2p27jhwm8vwsi">
            Delete Project
          </button>
        </div>}

      {open && confirming && <div className="mt-6 max-w-xl border border-paper/30 px-6 py-6" data-id="element-351" data-mp="330xjpl4d2cl3">
          <p className="font-display text-2xl leading-snug" data-id="element-352" data-mp="37yftfdq7cvu5">Permanently delete this project?</p>
          <p className="label-sm mt-4 leading-relaxed text-paper/40" data-id="element-353" data-mp="18neo4gtw542f">
            Use this only for test, duplicate or accidentally created projects. This cannot be
            undone.
          </p>

          <label className="mt-7 block" data-id="element-354" data-mp="15ltdx04bmdxx">
            <span className="label block text-paper/40" data-id="element-355" data-mp="15muq57x2p6h8">
              Type the project name to confirm · {activeProject.name}
            </span>
            <input value={typed} onChange={event => setTyped(event.target.value)} autoFocus className={FIELD} data-id="element-356" data-mp="1fj7ssvaliuo4" />
          </label>

          <div className="mt-7 flex flex-wrap items-center gap-6" data-id="element-357" data-mp="1oiul8rlckq51">
            <button type="button" disabled={!matches || busy} onClick={async () => {
          if (!matches || busy) return;
          setBusy(true);
          const done = await deleteProject();
          setBusy(false);
          if (done) close();
        }} className={`${BUTTON_SOLID} disabled:border-paper/25 disabled:bg-transparent disabled:text-paper/30`} data-id="element-358" data-mp="1ki0wxx3zt9bm">
              Delete Permanently
            </button>
            <button type="button" onClick={close} className={BUTTON_QUIET} data-id="element-359" data-mp="2mtslvsz4ejn2">
              Cancel
            </button>
          </div>

          <p className="label-sm mt-6 leading-relaxed text-paper/30" data-id="element-360" data-mp="2qumbqrw4i8il">
            The project, its deliverables, client feedback and its client link are removed. No other
            project is affected, and nothing is deleted from Google Drive.
          </p>
        </div>}
    </section>;
}